import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getPayouts: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: 'withdraw',
            responseType: params.excel ? 'blob' : 'json',
            params
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
                commit('SET_PAYOUTS', res.data.items)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    changeStatus: async({ dispatch, commit }, data) => {
        await request({ method: 'put', url: `/admin/withdraw/${data.id}`, data: {
            status: data.status
        }})
    },

    comment: async({ dispatch, commit }, { id, comment }) => {
        return request({
            method: 'put', url: `/admin/withdraw/${id}/comment`,
            data: { comment }
        }).then(res => res.status)
    },

    payout: async({ dispatch, commit }, data) => {
        return await request({ method: 'post', url: '/withdraw', data: { sum: data.sum }})
            .then(res => {
                if (res.data && res.data.withdraw) {
                    commit('ADD_PAYOUT', res.data.withdraw)
                    commit('SET_BALANCE', res.data.withdraw.balance, { root: true })
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        status: 'error',
                        message: error.response.data.message,
                        locale: true
                    }, { root: true })
                }
            })
    }
}
